import * as React from "react";
function SvgIcChartPivotTable(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8H2V4h6v4zM3 7h4V5H3v2zM22 8H9V4h13v4zM10 7h11V5H10v2zM8 20H2V9h6v11zm-5-1h4v-9H3v9zM22 20H9V9h13v11zm-12-1h11v-9H10v9z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChartPivotTable;
